import { useEffect, useState } from 'react';

/**
 * useResize is a custom React hook that listens for changes in the window size.
 * It attaches an event listener to the window's resize event and returns the
 * current width and height of the window. This allows components to reactively
 * adjust their layout or behavior based on the screen size. The hook also ensures
 * proper cleanup of the event listener when the component is unmounted to prevent
 * memory leaks.
 */
const useResize = () => {
  const [size, setSize] = useState({
    width: 0,
    height: 0,
  });

  const getSize = () => {
    setSize({
      width: window.innerWidth,
      height: window.innerHeight,
    });
  };

  useEffect(() => {
    getSize();

    window.addEventListener('resize', getSize);

    return () => {
      window.removeEventListener('resize', getSize);
    };
  }, []);

  return size;
};

export { useResize };
